const $ = window.jQuery
const ClipboardJS = require('clipboard')

$(() => {
  new ClipboardJS('.clipboard')
})
